export class Regex {

    static dayString  = /[0-9]{4}-(1[0-2]|0[0-9])-(3[0-1]|[0-2][0-9])/;
    static timeString = /(2[0-3]|[0-1][0-9]):([0-5][0-9])/;

    static endingWithSingleDigit = /\s[0-9]$/

}